import React from "react";
import { Container, Box, Typography } from "@mui/material";
import Footer from "../components/Footer";

const PrivacyPolicy: React.FC = () => {
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Container maxWidth="md" sx={{ py: 8, flex: 1 }}>
        <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
          Privacy Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last updated: December 21, 2025
        </Typography>

        <Box
          sx={{
            "& h2": { fontSize: "1.5rem", fontWeight: 600, mt: 4, mb: 2 },
            "& p, & li": { lineHeight: 1.8, mb: 2 },
          }}
        >
          <Typography variant="h5" component="h2">
            Introduction
          </Typography>
          <Typography variant="body1">
            This Privacy Policy describes how shashi-sharma.com.np ("we", "us",
            or "our") collects, uses, and shares your personal information when
            you visit our website.
          </Typography>

          <Typography variant="h5" component="h2">
            Information We Collect
          </Typography>
          <Typography variant="body1">
            We collect information that you provide directly to us, including:
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <li>Email address (when you contact us)</li>
            <li>Any other information you choose to provide</li>
          </Box>

          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            Automatically Collected Information
          </Typography>
          <Typography variant="body1">
            When you visit our website, we may automatically collect:
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <li>Browser type and version</li>
            <li>Pages you visit and time spent on those pages</li>
            <li>Referring website addresses</li>
            <li>IP address</li>
          </Box>

          <Typography variant="h5" component="h2">
            Use of Information
          </Typography>
          <Typography variant="body1">
            We use the collected information to:
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <li>Provide, maintain, and improve our services</li>
            <li>Respond to your comments and questions</li>
            <li>Analyze usage patterns and trends</li>
            <li>Detect, prevent, and address technical issues</li>
          </Box>

          <Typography variant="h5" component="h2">
            Cookies and Tracking
          </Typography>
          <Typography variant="body1">
            We may use cookies and similar tracking technologies to track
            activity on our website and store certain information. You can
            instruct your browser to refuse all cookies or to indicate when a
            cookie is being sent.
          </Typography>

          <Typography variant="h5" component="h2">
            Browser Storage
          </Typography>
          <Typography variant="body1">
            Our website uses browser storage (localStorage and sessionStorage)
            to improve your experience:
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <li>
              Saved stories/bookmarks - stored in localStorage to remember your
              saved Hacker News articles
            </li>
            <li>
              Feed preferences - stored in sessionStorage to preserve your
              selected news feed and filters during your session
            </li>
            <li>
              Scroll position - temporarily stored to restore your position when
              navigating back
            </li>
          </Box>
          <Typography variant="body1">
            This data is stored only in your browser and is never transmitted to
            our servers. You can clear this data at any time through your
            browser settings.
          </Typography>

          <Typography variant="h5" component="h2">
            Third-Party Services
          </Typography>
          <Typography variant="body1">
            We may use third-party services such as Google Analytics to monitor
            and analyze website traffic. Additionally, we integrate with:
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <li>
              Hacker News API - to fetch and display technology news stories
            </li>
            <li>
              External websites - embedded via iframes to display article
              content
            </li>
          </Box>
          <Typography variant="body1">
            When you view embedded content from external websites, those sites
            may collect their own data according to their privacy policies.
          </Typography>

          <Typography variant="h5" component="h2">
            Advertising (Google AdSense)
          </Typography>
          <Typography variant="body1">
            We use Google AdSense to display advertisements on this website.
            Google AdSense uses cookies and similar tracking technologies to
            serve ads based on your prior visits to this website and other sites
            on the internet. Google's use of advertising cookies enables it and
            its partners to serve ads based on your visit to this site and/or
            other sites on the internet.
          </Typography>
          <Typography variant="body1">
            You may opt out of personalized advertising by visiting{" "}
            <a
              href="https://www.google.com/settings/ads"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Ads Settings
            </a>
            . Alternatively, you can opt out of a third-party vendor's use of
            cookies for personalized advertising by visiting{" "}
            <a
              href="https://www.aboutads.info/choices/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.aboutads.info/choices
            </a>
            .
          </Typography>
          <Typography variant="body1">
            For more information on how Google uses data when you use our site,
            visit:{" "}
            <a
              href="https://policies.google.com/technologies/partner-sites"
              target="_blank"
              rel="noopener noreferrer"
            >
              How Google uses data from sites that use Google services
            </a>
            .
          </Typography>

          <Typography variant="h5" component="h2">
            Data Security
          </Typography>
          <Typography variant="body1">
            We take reasonable measures to protect your personal information
            from unauthorized access, alteration, or destruction.
          </Typography>

          <Typography variant="h5" component="h2">
            Changes to This Policy
          </Typography>
          <Typography variant="body1">
            We may update this Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page.
          </Typography>

          <Typography variant="h5" component="h2">
            Contact Us
          </Typography>
          <Typography variant="body1">
            If you have any questions about this Privacy Policy, please contact
            us at sharmashashi940@gmail.com
          </Typography>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
};

export default PrivacyPolicy;
